import React from 'react';
import {Link} from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  link?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className = '' }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb"
         className={`flex flex-nowrap items-center text-sm text-gray-600 leading-relaxed w-full mb-2 ${className}`}>
      {items.map((item, index) => (
        <BreadcrumbItemView key={index} item={item} isLast={index === items.length - 1} index={index}/>
      ))}
    </nav>
  );
};

interface BreadcrumbItemViewProps {
  item: BreadcrumbItem;
  isLast: boolean;
  index: number;
}

const BreadcrumbItemView: React.FC<BreadcrumbItemViewProps> = ({item, isLast, index}) => {
  return (
    <React.Fragment>
      {index > 0 && (
        <span className="mx-2 text-gray-400 select-none flex-shrink-0" aria-hidden="true">
          {'>'}
        </span>
      )}
      <span
        title={item.label}
        className="truncate min-w-0 flex-shrink"
      >
        {item.link ? (
          <Link
            to={item.link}
            className="hover:text-gray-900 hover:underline transition-colors duration-200"
          >
            {item.label}
          </Link>
        ) : (
          <span className="font-medium text-gray-800" aria-current="page">
            {item.label}
          </span>
        )}
      </span>
    </React.Fragment>
  );
};

export default Breadcrumbs;
